import * as React from 'react';
import { ActionPlanTopic, UnscoredSelectionStats, ScoredSelectionStats, SurveyTopic } from '../../../amorg-common';
import { Flex, FlexItem } from '../../../designSystem/compositeComponents/FlexHelpers';
import { AggregatedSurveyAnswerScoreRadialChart, SurveyQuestionAnswerScoreRadialChart } from '../../../designSystem/graphs/SurveyAnswerScoreRadialChart';
import { AggregatedSurveyAnswerRatioBar, QuestionSurveyAnswerRatioBar } from '../../workplaceassessments/[activityId]/_components/tabs/report/_components/SurveyAnswerRatioBar';
import { Span12 } from '../../../designSystem/typography/Body';



export function ActionPlanTopicContext (props: {
    topic: ActionPlanTopic;
    small: boolean;
}): JSX.Element | null
{
    if (props.topic.type === 'WPA')
    {
        return <ActionPlanSurveyTopicContext surveyTopic={props.topic.surveyTopic} small={props.small} />;
    }

    else
    {
        return null;
    }
}

export function ActionPlanSurveyTopicContext(props: {
    surveyTopic: SurveyTopic,
    small?: boolean;
}): JSX.Element | null
{
    const stats = props.surveyTopic.data.scoreMap === null
        ? new UnscoredSelectionStats(props.surveyTopic.data.selections)
        : new ScoredSelectionStats(props.surveyTopic.data.selections, props.surveyTopic.data.scoreMap);

    return (
        <Flex flexDirection="row" alignItems='center' gap={16}>
            <FlexItem style={{flexShrink: 0}}>
                {(props.surveyTopic.linkType === 'theme' || props.surveyTopic.linkType === 'indicator') &&
                    <AggregatedSurveyAnswerScoreRadialChart stats={stats} small={props.small} />}

                {props.surveyTopic.linkType === 'question' &&
                    <SurveyQuestionAnswerScoreRadialChart question={props.surveyTopic.question} stats={stats} small={props.small} />}
            </FlexItem>

            <Flex flexDirection="column" gap={4}>
                <Span12 fontWeight={500}>Svarfordeling</Span12>
                {(props.surveyTopic.linkType === 'theme' || props.surveyTopic.linkType === 'indicator') &&
                    <AggregatedSurveyAnswerRatioBar stats={stats as ScoredSelectionStats} small={props.small} />}
                {props.surveyTopic.linkType === 'question' &&
                    <QuestionSurveyAnswerRatioBar question={props.surveyTopic.question} stats={stats} small={props.small} />}
            </Flex>
        </Flex>
    );
}